import { format, isValid, parseISO } from 'date-fns'
import { ja } from 'date-fns/locale'
import { type FC } from 'react'

import { EMPTY_LABEL } from '@/constants'

type Props = {
  value: string | null | undefined // null と undefined を許容
  dateFormat?: string
  fallback?: string | null // fallback も null を許容
  className?: string
}

const DEFAULT_DATE_FORMAT = 'yyyy/MM/dd HH:mm'

/**
 * ISO形式の日付をフォーマットする
 */
export const DateFormatter: FC<Props> = ({
  value,
  dateFormat = DEFAULT_DATE_FORMAT,
  fallback,
  className
}) => {
  // value が null, undefined, または空文字列の場合は fallback または EMPTY_LABEL を表示
  if (value == null || (typeof value === 'string' && value.trim() === '')) {
    return <span className={className}>{fallback ?? EMPTY_LABEL}</span>
  }

  try {
    // value が string でない場合、または parseISO に失敗した場合は Date オブジェクトではない
    const date = typeof value === 'string' ? parseISO(value) : value

    // date が Date インスタンスかつ有効な日付かチェック
    if (!(date instanceof Date) || !isValid(date)) {
      console.warn(
        '[DateFormatter] Invalid date value received after parsing:',
        value,
        '(parsed as:',
        date,
        ')'
      )
      return <span className={className}>{fallback ?? EMPTY_LABEL}</span>
    }

    return (
      <time
        dateTime={typeof value === 'string' ? value : date.toISOString()}
        className={className}
      >
        {format(date, dateFormat, { locale: ja })}
      </time>
    )
  } catch (error) {
    console.error('[DateFormatter] Error during date processing:', value, error)
    return <span className={className}>{fallback ?? EMPTY_LABEL}</span>
  }
}
